import {
	HStack,
	VStack,
	Link,
	Text,
	IconAvatar,
	IconCompany,
} from '@montel/montelpro-shared-components-v2';
import { useGlobalContext } from 'components/common/GlobalContext/GlobalContext';
import { LabelAndValue } from 'components/common/LabelAndValue/LabelAndValue';
import { Subscription } from 'domain/subscription/interfaces/Subscription';
import ApplicationPermissionTabs from 'pages/Subscription/Permissions/ApplicationPermissionTabs';
import { styled } from 'styled-components';
import { SubscriberList } from './SubscriberList';
import { useCachedGet } from 'hooks/useCachedGet';
import { SubscriptionBundle } from 'domain/subscription/interfaces/SubscriptionBundle';
import { BUNDLES_GET_BUNDLE } from 'apiRoutes';

const ExpandedContent = styled(VStack)`
	padding: ${({ theme }) => theme.spacing.lg};
`;

export const ExpandedSubscriptionContent: React.FunctionComponent<{
	subscription: Subscription;
}> = ({ subscription }) => {
	const { toApplicationPermissions } = useGlobalContext();

	const { data: bundle } = useCachedGet<SubscriptionBundle>(
		subscription?.bundleId
			? `${BUNDLES_GET_BUNDLE}?bundleId=${subscription.bundleId}`
			: '',
	);

	const hasSubscribers =
		!!subscription.subscribers.length ||
		!!subscription.systemEntitySubscribers.length;

	return (
		<ExpandedContent fullWidth gap="xxl">
			<HStack fullWidth gap="10xl">
				{subscription.bundleId && (
					<LabelAndValue
						label="In bundle"
						value={
							<Link
								href={`/subscription-bundles/${subscription.bundleId}`}
							>
								<HStack align="center">
									{subscription.bundleId}
								</HStack>
							</Link>
						}
					/>
				)}
				<LabelAndValue
					label="Description"
					value={subscription.description || '-'}
				/>
				<LabelAndValue
					label="Owner"
					value={
						subscription.companyId ? (
							<Link href={`/companies/${subscription.companyId}`}>
								<HStack align="center">
									<IconCompany /> {subscription.companyName}
								</HStack>
							</Link>
						) : (
							<HStack align="center">
								<IconAvatar /> <span>User</span>
							</HStack>
						)
					}
				/>
			</HStack>

			<HStack fullWidth gap="10xl">
				<VStack gap="md">
					<Text size={'xs'} color={'textSubtle'}>
						Product Permissions
					</Text>
					<ApplicationPermissionTabs
						applicationsPermissions={toApplicationPermissions(
							subscription.applicationPermissions,
						)}
						bundle={bundle}
					/>
				</VStack>
				{hasSubscribers && (
					<VStack gap="md">
						<SubscriberList
							accountSubscribers={subscription.subscribers}
							systemEntitySubscribers={
								subscription.systemEntitySubscribers
							}
						/>
					</VStack>
				)}
			</HStack>
		</ExpandedContent>
	);
};
